(function () {
	'use strict';

	// Style password protected post form.
	const passwordButton = document.querySelector('.post-password-form [type="submit"]');
	if (document.body.contains(passwordButton)) {
		const passwordButtonWrapper = document.createElement('div');
		passwordButtonWrapper.classList.add('wp-block-button');
		passwordButton.parentNode.insertBefore(passwordButtonWrapper, passwordButton);
		passwordButtonWrapper.appendChild(passwordButton);

		passwordButton.classList.add('wp-block-button__link');
	}

	// Play video on post click
	const video = document.getElementsByTagName('video');
	if (video) {
		for (let i = 0; i < video.length; i++) {
			video[i].addEventListener('click', function () {
				this.paused ? this.play() : this.pause();
			});
		}
	}

	// Sticky Header
	let menu = document.getElementsByTagName('header')[0];
	var oldScrollY = window.scrollY;
	if (menu && menu.classList.contains('has-sticky')) {
		window.addEventListener('scroll', () => {
			let pos;
			if (menu.classList.contains('sticky')) {
				pos = 116; // height of div, if sticky
			} else {
				pos = 200; // height of div, if not sticky
			}
			window.scrollY > pos ? menu.classList.add('sticky') : menu.classList.remove('sticky');

			if (oldScrollY < 0) {
				// Fix for Safari
				menu.classList.remove('scroll-down');
			} else {
				window.scrollY > oldScrollY
					? menu.classList.add('scroll-down')
					: menu.classList.remove('scroll-down');
			}

			oldScrollY = window.scrollY;
		});
	}

	// Expand / Collapse Details
	const details = document.getElementsByTagName('details');

	if (details.length !== 0 && document.getElementsByClassName('detailsBtn').length !== 0) {
		const detailsBtn = document.getElementsByClassName('detailsBtn')[0];

		detailsBtn.addEventListener('click', function () {
			if (detailsBtn.firstElementChild.innerText === 'Expand all') {
				for (let i = 0; i < details.length; i++) {
					details[i].setAttribute('open', '');
				}
				detailsBtn.firstElementChild.innerText = 'Collapse all';
			} else {
				for (let i = 0; i < details.length; i++) {
					if (details[i].hasAttribute('open')) {
						details[i].removeAttribute('open');
					}
				}
				detailsBtn.firstElementChild.innerText = 'Expand all';
			}
		});
	}
})();
